import { useQuery, UseQueryResult } from 'react-query'
import { get } from '@fable/api'
import { AxiosResponse } from 'axios'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'

export interface GenresStreamBreakdown {
  genre: string
  percentage: number
}

export interface GenresStreamItem {
  id: string
  start_at: string
  end_at: string
  number_goal: number
  number_achieved: number
  breakdown: GenresStreamBreakdown[]
}

export type GenresStreamResponse = AxiosResponse<GenresStreamItem[]>

const getData = async ({
  userId,
  periodType,
  year,
}: {
  userId: string
  periodType: 'week' | 'month'
  year: number
}) =>
  await get(
    `/advanced_stats/genre_stream/?user_id=${userId}&period_type=${periodType}&year=${year}`
  )

export const useChartUsery = ({ enabled = false }: { enabled: boolean }) => {
  const [year, userId] = useStats((s) => [s.year, s.statsUserId])
  const periodType = 'month'
  const queryKey = ['stats-genre-stream', userId, periodType, year]

  const query: UseQueryResult<GenresStreamResponse> = useQuery(
    queryKey,
    () => getData({ userId, periodType, year }),
    {
      enabled: !!enabled && !!userId && !!periodType,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      staleTime: 0,
      cacheTime: 0,
    }
  )

  return query
}
